import React, { useState, useEffect, useRef } from 'react';
import { Button, Space, DatePicker, Table, Alert, ConfigProvider, Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { EmptyFileColor, Search } from 'patternx-svg';
import type { DatePickerProps } from 'antd';
// import moment from 'antd/node_modules/moment';
import moment from 'moment';
import 'moment/locale/zh-cn';
// import locale from 'antd/lib/locale/zh_CN';
import PtxEmpty from '@/components/ptx-empty';
import { getMtbfs, getEarliestTime } from '../../../../services/initial';
import { isNaN } from 'lodash-es';
import type { RangePickerProps } from 'antd/es/date-picker';
import './index.less';
import { useCallbackFn } from '@/hooks';

moment.locale('zh-cn');

type searchParams = {
  from: number;
  to: number;
};

const endTime = moment().endOf('day');
const List1: React.FC<{}> = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [param, setParam] = useState<searchParams>({
    to: endTime.valueOf(),
  } as searchParams);
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1); // 当前页码
  const [size, setSize] = useState<number>(10); // 每页显示数据数量
  const [total, setTotal] = useState<number>(0); // 总共数据量
  const [mtbf, setMtbf] = useState('');
  const [startTime, setStartTime] = useState<any>(undefined);
  const defaultDisabledDate = useRef<any>();
  const [isCrash, setIsCrash] = useState(false);

  const onChange1: DatePickerProps['onChange'] = (date, s) => {
    const from = moment(s).startOf('day').valueOf();
    setParam({
      ...param,
      from,
    });
    setStartTime(date);
    setPage(1);
    getDatas({
      from,
      page: 1,
    });
  };

  const onChange2: DatePickerProps['onChange'] = (date, s) => {
    const to = moment(s).endOf('day').valueOf();
    setParam({
      ...param,
      to,
    });
    setPage(1);
    getDatas({
      to,
      page: 1,
    });
  };

  const columns: any = [
    {
      title: '开始时间',
      dataIndex: 'startTime',
      key: 'startTime',
      width: 200,
      render: (text: any) => <div style={{ width: 160 }}>{text}</div>,
    },
    {
      title: '结束时间',
      dataIndex: 'endTime',
      key: 'endTime',
      width: 200,
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '是否异常',
      dataIndex: 'crash',
      key: 'crash',
      width: 100,
      render: (text: any) => <div style={{ width: 60 }}>{!!text ? '是' : '否'}</div>,
    },
    {
      title: '实例id',
      dataIndex: 'instanceId',
      key: 'instanceId',
      width: 200,
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: 'user',
      dataIndex: 'user',
      key: 'user',
      width: 130,
      render: (text: any) => <div style={{ width: 90 }}>{text || '-'}</div>,
    },
    {
      title: '主键id',
      dataIndex: 'id',
      key: 'id',
      width: 200,
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: 'ip',
      dataIndex: 'ip',
      key: 'ip',
      width: 120,
      render: (text: any) => <div style={{ width: 90 }}>{text || '-'}</div>,
    },
    {
      title: 'port',
      dataIndex: 'port',
      key: 'port',
      width: 100,
      render: (text: any) => <div style={{ width: 60 }}>{text || '-'}</div>,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 200,
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 200,
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
  ];

  const renderEmpty = () => {
    return <PtxEmpty isEmpty={true} describe="暂无数据" icon={<EmptyFileColor />} />;
  };

  const returnParam = (params?: { value1?: number; value2?: number }) => {
    if (isNaN(params?.value1)) {
      return undefined;
    }
    if (!params?.value1) {
      return params?.value2 || undefined;
    }
    return params?.value1;
  };

  const getStartTime = async () => {
    const res = await getEarliestTime();
    if (res?.success) {
      const from = moment(res?.data?.data);
      setStartTime(from);
      defaultDisabledDate.current = from;
      setParam({
        ...param,
        from: from.valueOf(),
      });
      getDatas({
        from: from.valueOf(),
        to: endTime.valueOf(),
      });
    }
  };

  const getMtbf = (unFailureTime: number, failureTimes: number) => {
    const totalTimes = Math.round(unFailureTime / 1000 / 60 / 60);
    const values = failureTimes ? (totalTimes / failureTimes).toFixed(1) : '--';
    return `MTBF: ${totalTimes} / ${failureTimes} = ${values} (h)`;
  };

  const getDatas = async (params?: {
    from?: number;
    to?: number;
    page?: number;
    pageSize?: number;
    onlyCrash?: boolean;
  }) => {
    setIsLoading(true);
    const res = await getMtbfs({
      from: returnParam({ value1: params?.from, value2: param?.from }),
      to: returnParam({ value1: params?.to, value2: param?.to }),
      page: params?.page || page,
      pageSize: params?.pageSize || size,
      onlyCrash: params?.onlyCrash !== undefined ? params?.onlyCrash : isCrash,
    });
    setIsLoading(false);
    if (res?.success) {
      const datas = res?.data?.data;
      setData(datas?.items || []);
      setTotal(datas?.totalItemCount || 0);
      setMtbf(getMtbf(datas?.unFailureTime || 0, datas?.failureTimes || 0));
    }
  };
  useEffect(() => {
    getStartTime();
  }, []);

  const onSearch = () => {
    getDatas({
      page: 1,
    });
    setPage(1);
  };

  const disabledDate: RangePickerProps['disabledDate'] = useCallbackFn((current) => {
    return current && current < moment(defaultDisabledDate.current);
  });

  const onChange = (e: CheckboxChangeEvent) => {
    const isChecked = e.target.checked;
    setIsCrash(isChecked);
    getDatas({
      page: 1,
      onlyCrash: isChecked,
    });
  };

  return (
    <div className="mbtf-list-content">
      <div className="mbtf-list-search">
        <Space>
          <span>开始时间：</span>
          <DatePicker onChange={onChange1} value={startTime} disabledDate={disabledDate} />
          <span>-</span>
          <DatePicker onChange={onChange2} defaultValue={endTime} disabledDate={disabledDate} />
          <span>只看异常：</span>
          <Checkbox onChange={onChange} checked={isCrash}>
            是
          </Checkbox>
          <Button type="primary" icon={<Search />} onClick={onSearch} />
        </Space>
        <Alert message={mtbf ? `${mtbf}` : '无异常'} type={mtbf ? 'info' : 'success'} />
      </div>

      <div className="mbtf-list-table">
        <ConfigProvider renderEmpty={renderEmpty}>
          <Table
            rowKey={(record) => record.id}
            loading={isLoading}
            columns={columns}
            dataSource={data}
            pagination={{
              size: 'small',
              showTotal: (total, range) => {
                return `${range[0]}-${range[1]}条，共${total}条`;
              },
              showTitle: true,
              showQuickJumper: false,
              showSizeChanger: true,
              total: total, // 分页总数
              pageSize: size, // 每页数量
              current: page, // 当前页数
              onChange: (p, s) => {
                setPage(p);
                setSize(s as number);
                getDatas({
                  page: p,
                  pageSize: s,
                });
              },
            }}
            scroll={{ x: 1600, y: 'calc(100vh - 340px)' }}
          />
        </ConfigProvider>
      </div>
    </div>
  );
};

export default List1;
